import React from 'react'
import { useDepartmentsList, DepartmentsListProps } from './useDepartmentsList'
import List from './List/List'
import styles from './DepartmentsList.module.scss'

const DepartmentsList: React.FC<DepartmentsListProps> = (
  props: DepartmentsListProps
) => {
  const { isAr, departments, t } = useDepartmentsList(props)

  return (
    <section className={styles['departments-listing']}>
      <div className='container'>
        <List departments={departments} isAr={isAr} t={t} />
      </div>
    </section>
  )
}

export default DepartmentsList
